(() => {
  if (customElements.get('ellivvibebe-video-card')) return;
  class EllivvibebeVideoCard extends HTMLElement {
    static tiktokId(value) {
      try {
        const url = new URL(value);
        if (url.protocol !== 'https:' || !['www.tiktok.com', 'tiktok.com'].includes(url.hostname)) return null;
        return url.pathname.match(/^\/@[\w.-]+\/video\/(\d+)\/?$/)?.[1] || null;
      } catch { return null; }
    }

    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const button = this.querySelector('[data-video-play]');
      const video = this.querySelector('video');
      button?.addEventListener('click', () => this.openTikTok(), { signal });
      video?.addEventListener('play', () => this.announcePlay(), { signal });
      document.addEventListener('ellivvibebe:video-play', (event) => {
        if (event.detail !== this) this.pause();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
      }, { signal });
      window.addEventListener('message', (event) => {
        if (event.origin !== 'https://www.tiktok.com' || event.source !== this.frame?.contentWindow || !event.data?.['x-tiktok-player']) return;
        if (event.data.type === 'onPlayerReady') {
          clearTimeout(this.loadingTimer);
          this.status('');
        } else if (event.data.type === 'onPlayerError') {
          clearTimeout(this.loadingTimer);
          this.status('Video unavailable here. Use the TikTok link below to watch.');
        } else if (event.data.type === 'onStateChange' && event.data.value === 1) {
          this.announcePlay();
        }
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) this.pause();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
    }

    status(message) {
      const node = this.querySelector('[data-video-status]');
      if (node) { node.textContent = message; node.hidden = !message; }
    }

    openTikTok() {
      if (this.frame) return;
      const id = EllivvibebeVideoCard.tiktokId(this.dataset.tiktokUrl);
      if (!id) { this.status('Please use a full TikTok video link.'); return; }
      const frame = document.createElement('iframe');
      frame.src = `https://www.tiktok.com/player/v1/${id}?controls=1&autoplay=1&rel=0`;
      frame.title = this.dataset.videoTitle || 'TikTok video';
      frame.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.addEventListener('error', () => this.status('Video unavailable here. Use the TikTok link below to watch.'), { signal: this.controller.signal });
      this.frame = frame;
      this.querySelector('[data-video-media]').append(frame);
      this.querySelector('[data-video-play]').hidden = true;
      this.status('Loading TikTok…');
      this.loadingTimer = setTimeout(() => this.status('If the video does not load, use the TikTok link below.'), 15000);
      this.announcePlay();
      frame.focus();
    }

    announcePlay() {
      document.dispatchEvent(new CustomEvent('ellivvibebe:video-play', { detail: this }));
    }

    pause() {
      this.querySelector('video')?.pause();
      this.frame?.contentWindow?.postMessage({ type: 'pause', 'x-tiktok-player': true }, 'https://www.tiktok.com');
    }

    disconnectedCallback() {
      this.pause();
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.loadingTimer);
    }
  }
  customElements.define('ellivvibebe-video-card', EllivvibebeVideoCard);
})();
